import { render, staticRenderFns } from "./SupervisorRegion.vue?vue&type=template&id=05af980a&scoped=true"
import script from "./SupervisorRegion.vue?vue&type=script&lang=js"
export * from "./SupervisorRegion.vue?vue&type=script&lang=js"
import style0 from "./SupervisorRegion.vue?vue&type=style&index=0&id=05af980a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af980a",
  null
  
)

export default component.exports